export const API_DOMAIN = process.env.NODE_ENV === 'production' ? "https://www.stockservant.net" : "http://localhost:8889";